<template>
  <div
    id="pageRoot"
    class="backgroundDeaf"
    style="background-color: var(--book-background-color)"
  >
    <span class="normalTheme pageInstruction" style="left: 67px; top: 111px">
      <p>Completa el globo con tus datos y sube tu foto.</p>
    </span>

    <div
      class="pageElement text-box-a hover-animation-a"
      id="globe01"
      style="background-image: url(/pages/img/intro/svg05Globe01.svg)"
    >
      <p class="textBase" id="textBox01Text">
        ME GUSTARÍA<br />
        CONOCERTE.
      </p>
    </div>
    <img
      id="zorrito"
      class="pageElement"
      src="/pages/img/intro/svg06Zorrito.svg"
    />

    <img
      id="globe02"
      class="pageElement"
      src="/pages/img/intro/svg06GlobeText.svg"
    />
    <h2 id="text01">ME LLAMO</h2>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />

    <h2 id="text02">TENGO</h2>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <h2 id="text03">AÑOS</h2>

    <uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>
    <div
      id="button01"
      style="position: absolute; margin-left: 2.5%; margin-top: 66%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
      ></image-upload>
    </div>
  </div>
</template>
<style scoped>
@import "../../../assets/css/sordoStyle.css";

#globe01 {
  position: absolute;
  width: 338px;
  height: 170px;
  left: 74px;
  top: 280px;
  z-index: 1;
}
#textBox01Text {
  position: absolute;
  width: 385px;
  left: -30px;
  top: 25px;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
  color: #fbf8f8;
}
#zorrito {
  position: absolute;
  left: 26px;
  top: 457px;
}
#globe02 {
  position: absolute;
  left: 436px;
  top: 171px;
  z-index: 1;
}
#text01 {
  position: absolute;
  left: 458px;
  top: 193px;
  z-index: 2;
}
#text02 {
  position: absolute;
  left: 500px;
  top: 255px;
  z-index: 2;
}
#text03 {
  position: absolute;
  left: 745px;
  top: 255px;
  z-index: 2;
}
#inputField01 {
  position: absolute;
  width: 240px;
  height: 35px;
  left: 600px;
  top: 190px;
  z-index: 2;
}
#inputField02 {
  position: absolute;
  width: 102px;
  height: 35px;
  left: 600px;
  top: 260px;
  z-index: 2;
}
.image01 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 440px;
  top: 367px;
  z-index: 0;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 690px;
  top: -30px;
}
</style>

<script>
import ImageUpload from "../../../components/ImageUpload.vue";
export default {
  name: "App",
  components: {
    ImageUpload,
  },
};
</script>